import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  "data-testid": "table-views-publish-warning"
}

import { useStore } from 'vuex';

import { RcButton } from '@components/RcButton';
import { RcModal } from '@components/RcModal';
import { useI18n } from '@shell/composables/useI18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'TableViewPublishModal',
  props: {
    modal: {},
    hasFilter: { type: Boolean, default: false }
  },
  emits: ["publish"],
  setup(__props: any, { emit: __emit }) {

/**
 * Asks before a view is published for everyone, saying what its filter gives away when it has one
 */
const props = __props;

const emit = __emit;

const store = useStore();
const { t } = useI18n(store);

const publish = () => {
  emit('publish');
  props.modal.onClose();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(RcModal), _mergeProps(__props.modal, {
    title: _unref(t)('tableViews.publish.title'),
    "data-testid": "table-views-publish-modal"
  }), {
    "primary-action": _withCtx(() => [
      _createVNode(_unref(RcButton), {
        variant: "primary",
        size: "large",
        "data-testid": "table-views-publish-confirm",
        onClick: publish
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('tableViews.tab.share')), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("p", null, _toDisplayString(_unref(t)('tableViews.publish.body')), 1),
      _cache[0] || (_cache[0] = _createTextVNode()),
      (__props.hasFilter)
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_unref(t)('tableViews.filterWarning', undefined, true)), 1))
        : _createCommentVNode("", true),
      _cache[1] || (_cache[1] = _createTextVNode())
    ]),
    _: 1
  }, 16, ["title"]))
}
}

})